import {useEffect} from 'react';
import {useHeartbeatApi} from '../../hooks/useHeartbeatApi';
import {useHeartbeatPermissions} from '../../hooks/useHeartbeatPermissions';
import {HeartbeatDaemonProps} from '../../interfaces/HeartbeatDaemonProps';
import {HeartbeatTimer} from '../../services/HeartbeatTimer';

export function HeartbeatDaemon({interval}: HeartbeatDaemonProps): JSX.Element | null {
  const hasHeartbeatPermissions = useHeartbeatPermissions();

  const {sendHeartbeat} = useHeartbeatApi();

  useEffect(() => {
    if (!hasHeartbeatPermissions) {
      return;
    }
    const heartbeatTimer = HeartbeatTimer({
      intervalTime: interval,
      callbackFn: () => {
        void sendHeartbeat();
      },
    });

    heartbeatTimer.start();

    return () => {
      heartbeatTimer.stop();
    };
  }, [sendHeartbeat, hasHeartbeatPermissions, interval]);

  return null;
}
